// UI
import { Button, Dropdown, Text } from '@/ui'

// BL
import { UserDocument } from '../lib/userDocuments.slice'
import { useFeatureDispatch, openDeleteConfirm } from '../lib/state'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

interface UserDocumentActionButtonProps {
  document: UserDocument
}

export const UserDocumentActionButton = ({
  document,
}: UserDocumentActionButtonProps) => {
  const dispatch = useFeatureDispatch()

  const openConfirm = () => {
    dispatch?.(openDeleteConfirm(document))
  }

  return (
    <Dropdown>
      <Dropdown.Trigger asChild>
        <Button
          variant="discreet"
          size="square"
          iconRight={solid('ellipsis')}
        />
      </Dropdown.Trigger>

      <Dropdown.Content align="end">
        <Dropdown.Item onClick={openConfirm}>
          <Text>Delete File</Text>
        </Dropdown.Item>
      </Dropdown.Content>
    </Dropdown>
  )
}
